function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 8l4 4-4 4M8 12h7"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/next.39f3a3b9.svg";
export { SvgComponent as ReactComponent };